// extracted by extract-css-chunks-webpack-plugin
module.exports = {"list":"list_2o_Gn","item":"item_22DQu","pic":"pic_2S_bK","tag":"tag_3TmmS"};